export default {
  path: '/process_schemas',
  name: 'process_schemas',
  component: () => import('../components/processschema/Layout'),
  redirect: { name: 'ProcessSchemaList' },
  meta: {
    breadcrumb: 'process.processesschema',
  },
  children: [
    {
      name: 'ProcessSchemaList',
      path: '',
      component: () => import('../views/processschema/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProcessSchemaCreate',
      path: 'new',
      component: () => import('../views/processschema/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProcessSchemaUpdate',
      path: ':id/edit',
      component: () => import('../views/processschema/Update'),
      meta: {
        breadcrumb: 'process.processschema',
      },
    },
    {
      name: 'ProcessSchemaShow',
      path: ':id',
      component: () => import('../views/processschema/Show'),
      meta: {
        breadcrumb: 'process.processschema',
      },
    }
  ]
};
